module.exports = __webpack_public_path__ + "static/media/visitMallIcon.6571ae68.svg";